import React, { useState, useEffect } from "react";
import { Worker, Viewer } from "@react-pdf-viewer/core";
import { zoomPlugin } from "@react-pdf-viewer/zoom";
import { defaultLayoutPlugin } from "@react-pdf-viewer/default-layout";
import "@react-pdf-viewer/core/lib/styles/index.css";
import "@react-pdf-viewer/default-layout/lib/styles/index.css";
import "../css/Pdf.css";

const PdfModal = ({ pdfUrl, pdfUrlMobile, onClose }) => {
  const [isMobile, setIsMobile] = useState(false);
  const [currentUrl, setCurrentUrl] = useState(pdfUrl);

  const zoomPluginInstance = zoomPlugin();
  const {zoomTo } = zoomPluginInstance;

  const defaultLayoutPluginInstance = defaultLayoutPlugin({
    sidebarTabs: () => [],
    toolbarPlugin: {
      fullScreenPlugin: { enableShortcuts: false },
    },
  });

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 840);
    };

    handleResize();

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, [window?.innerWidth]);

  useEffect(() => {
    const timer = setTimeout(() => {
      zoomTo(0.6); // 60% zoom
    }, 500); // Delay agar Viewer sudah ready
    return () => clearTimeout(timer);
  }, [currentUrl]);


  const handleDownloadFile = async () => {
    try {
      const fileName = decodeURIComponent(currentUrl.split("/").pop().split("?")[0]);
      const response = await fetch(currentUrl);
      if (!response.ok) throw new Error("Failed to fetch file");

      const blob = await response.blob();
      const url = URL.createObjectURL(blob);

      const link = document.createElement("a");
      link.href = url;
      link.download = fileName;
      document.body.appendChild(link);
      link.click();
      link.remove();

      URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Download failed:", error);
    }
  };

  return (
    <div className="pdf-modal">
      <div className="pdf-toolbar">
        <button onClick={onClose} className="btn close-btn">Close</button>
      </div>

      <div className="pdf-viewer-container">

        <Worker workerUrl={`https://unpkg.com/pdfjs-dist@3.11.174/build/pdf.worker.min.js`}>
          <Viewer
            fileUrl={currentUrl}
            plugins={[zoomPluginInstance, defaultLayoutPluginInstance]}
          />
        </Worker>
      </div>
    </div>
  );
};

export default PdfModal;
